<template>
  <div id="system-journal-setting-email-setting">
    <div class="flex mar-b-20">
      <div>The following email are prohibited from submission</div>
      <ipub-tooltip placement="bottomLeft"
                    class="mar-l-10">
        <div slot="title">
          The following email are prohibited from submission
        </div>
        <ipub-icon type="iconInfo" />
      </ipub-tooltip>
      <div v-if="user.codeList&&user.codeList.includes('SYSTEM.PUBLISHER_SETTING.GENERAL.SUBMISSION_PROHIBITED_EDIT')">
        <a class="mar-l-20"
           v-show="isShow"
           @click="()=>{isShow=!isShow}">
          <ipub-icon style="font-size:16px"
                     type="iconEditPen" />
        </a>
      </div>

    </div>
    <ipub-input tag
                :disabled="isShow"
                class="mar-b-30"
                placeholder="Please use a semicolon or carriage return to separate"
                v-model="params.emailLists" />
    <div class="btns">
      <ipub-button v-show="!isShow"
                   @click="()=>{isShow=!isShow}"
                   style="width:100px;">Cancel</ipub-button>
      <ipub-button v-show="!isShow"
                   style="width:100px;"
                   class="mar-l-8"
                   @click="submit"
                   type="primary">Save</ipub-button>
    </div>
  </div>

</template>


<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>